<template>
    <modal
        :adaptive="true"
        :class="{ 'mobile-item-modal': pivotY === 1 }"
        :clickToClose="true"
        :maxWidth="575"
        :pivotY="pivotY"
        :reset="true"
        height="auto"
        name="modifier-extra-info-modal"
        transition="pop-out"
        width="575"
        @before-open="beforeOpen"
    >
        <div class="item-modal-content relative flex flex-col w-full">
            <button
                aria-label="Hide modifier-extra-info modal"
                class="top-2 right-2 w-fit absolute rounded hover:bg-gray-100"
                type="button"
                @click="$modal.hide('modifier-extra-info-modal')"
            >
                <close-icon />
            </button>
            <div
                class="item-modal-details gap-3 flex flex-col select-none items-center bg-secondary flex-auto p-8 overflow-y-auto"
            >
                <h4 class="text-primary text-xl text-center font-bold">
                    {{ item }}
                </h4>
                <div class="h-0.5 w-full bg-black" />
                <p class="self-start mt-1 mb-3 whitespace-pre-line">
                    {{ text }}
                </p>
            </div>
        </div>
    </modal>
</template>

<script>
import isMobile from '@/helpers/isMobileDevice';
import CloseIcon from '@/components/icons/CloseIcon';

export default {
    name: 'allergen-modal',

    components: {
        CloseIcon
    },

    data() {
        return {
            item: '',
            text: ''
        };
    },

    computed: {
        pivotY() {
            return isMobile() ? 1 : 0.5;
        }
    },

    methods: {
        beforeOpen({ params: { item = '', text = '' } }) {
            this.item = item;
            this.text = text;
        }
    }
};
</script>
